import React, { useState, useEffect } from "react";
import { FiArrowRight } from "react-icons/fi";

import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import { withAlert, types } from "react-alert";
import { useTranslation } from "react-i18next";
import Line from "../../../images/tlf-line-qr.svg";
import { sendMail } from "../../../actions/admin/mail";
import { useSelector, useDispatch } from "react-redux";
import { getPageContents } from "../../../actions/admin/cmspage";
import { useLoading } from "../../../components/LoadingContext";
import LazyImage from "../../../components/common/LazyImage";
import { cn } from "../../../utils/classnames";
import { Input } from "../../../components/ui/Input";
import { PhoneInput } from "../../../components/ui/Input";
import { Textarea } from "../../../components/ui/Textrea";
import SuccessModal from "../../../components/modal/SuccessModal";

const bg_image = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-contact/background-image.jpg";
const Contact = ({ alert }) => {
  const page_name = "cms-contact";
  const dispatch = useDispatch();
  const cmspage_state = useSelector((state) => state.cmspage);
  const { cmspage, loading } = cmspage_state;
  const { t } = useTranslation();
  useEffect(() => {
    dispatch(getPageContents(page_name));
  }, [dispatch]);
  const { showLoading, closeLoading } = useLoading();
  const [isloading, setIsloading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [formData, setFormData] = useState({
    companyname: "",
    contactperson: "",
    phone: "",
    email: "",
    inquiry: "",
    countryCode: "JP",
    dialCode: "+81",
  });

  const clearForm = () => {
    setFormData({
      companyname: "",
      contactperson: "",
      phone: "",
      email: "",
      inquiry: "",
      countryCode: "JP",
      dialCode: "+81",
    });
  };

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmitForm = async () => {
    if (validateFrom()) await sendMailToClient();
  };

  const validateFrom = () => {
    if (
      formData.companyname === "" ||
      formData.contactperson === "" ||
      formData.phone === "" ||
      formData.email === "" ||
      formData.inquiry === ""
    ) {
      alert.show(t("Please fill all the fields"), { type: types.ERROR });
      return false;
    } else return true;
  };

  const sendMailToClient = async () => {
    setIsloading(true);
    const mailRes = await sendMail(
      "info@theluxuryfleet.com",
      "New inquiry from contact form " + formData.contactperson,
      getEmailBody()
    );
    if (mailRes.msg === "success") {
      clearForm();
      setShowSuccessModal(true);
    } else {
      alert.show(t("Something wrong."), { type: types.ERROR });
    }
    setIsloading(false);
  };

  const getEmailBody = () => {
    return (
      "<hr/><p>Company Name : " +
      formData.companyname +
      "</p><p>Full Name: " +
      formData.contactperson +
      "</p><p>Contact Number: " +
      formData.phone +
      "</p><p>Email : " +
      formData.email +
      "</p><p>Inquiry details : " +
      formData.inquiry +
      "</p><hr/>"
    );
  };

  return (
    <FrontLayout>

      {loading ? showLoading(true) : closeLoading(true)}
      <div className="tw:relative tw:max-w-[1920px] tw:mx-auto tw:font-hanken-grotesk tw:bg-[#f6f6f6]">
        <div className="tw:max-w-[1920px] tw:m-auto tw:relative">
          <div className="tw:bg-[linear-gradient(87.06deg,#000000_6.43%,rgba(40,42,45,0.3)_46.3%)] tw:w-full tw:h-full tw:absolute tw:top-0 tw:left-0 tw:z-20"></div>
          <LazyImage
            src={bg_image}
            alt="Contact Banner"
            wrapperClassName="tw:w-full tw:h-[430px] tw:lg:h-[430px] tw:relative tw:z-0"
            className="tw:w-full tw:h-full tw:object-cover"
          />
          <div className="tw:absolute tw:left-5 tw:bottom-8 tw:lg:left-[82px] tw:lg:bottom-[65px] tw:space-y-[14px] tw:z-50">
            <div className="tw:text-[rgba(219,190,120,1)] tw:text-[8px] tw:tracking-[3px] tw:font-semibold tw:font-hanken-grotesk tw:leading-none tw:uppercase">
              {t('contact.Banner.Tag')}
            </div>
            <div className="tw:text-[34px] tw:lg:text-[45px] tw:font-libre-caslon-display tw:leading-[58px] tw:text-white tw:font-normal">
              {t('contact.Banner.Title')}
            </div>
          </div>
        </div>
        <div className="tw:flex tw:flex-col tw:lg:flex-row tw:gap-y-8 tw:lg:gap-x-[53px] tw:lg:mt-[54px] tw:lg:mx-[84px] tw:pb-[88px]">
          {/* Inquiry Form */}
          <div className="tw:flex-1 tw:py-8 tw:px-5 tw:lg:px-7 tw:lg:py-8 tw:bg-white tw:border tw:border-[#f6f6f6] tw:rounded-[5px]">
            <div className="tw:space-y-[30px]">
              {/* Title */}
              <div className="tw:text-[20px] tw:font-semibold tw:leading-[28px] tw:text-[#282828] tw:font-hanken-grotesk">
                {t('contact.Form.Title')}
              </div>

              {/* Divider */}
              <div className="tw:h-[1px] tw:w-full tw:bg-[#e8e8e8]"></div>

              {/* Form Fields */}
              <div className="tw:space-y-4">
                {/* Name */}
                <Input
                  name="contactperson"
                  label={t('contact.Form.Field.Name')}
                  placeholder={t('contact.Form.Field.NamePlaceholder')}
                  value={formData.contactperson}
                  onChange={onChange}
                />

                {/* Company Name */}
                <Input
                  name="companyname"
                  label={t('contact.Form.Field.CompanyName')}
                  placeholder={t('contact.Form.Field.CompanyNamePlaceholder')}
                  value={formData.companyname}
                  onChange={onChange}
                />

                {/* Phone Number */}
                <PhoneInput
                  name="phone"
                  label={t('contact.Form.Field.PhoneNumber')}
                  placeholder={t('contact.Form.Field.PhoneNumberPlaceholder')}
                  value={formData.phone}
                  onChange={onChange}
                  countryCode={formData.countryCode}
                  dialCode={formData.dialCode}
                  onCountryChange={(code, dial, name) => {
                    setFormData(prev => ({
                      ...prev,
                      countryCode: code,
                      dialCode: dial,
                    }));
                  }}
                />

                {/* Email Address */}
                <Input
                  name="email"
                  type="email"
                  label={t('contact.Form.Field.EmailAddress')}
                  placeholder={t('contact.Form.Field.EmailAddressPlaceholder')}
                  value={formData.email}
                  onChange={onChange}
                />

                {/* Inquiry Details */}
                <Textarea
                  name="inquiry"
                  label={t('contact.Form.Field.InquiryDetails')}
                  placeholder={t('contact.Form.Field.InquiryDetailsPlaceholder')}
                  value={formData.inquiry}
                  onChange={onChange}
                />
              </div>
            </div>

            {/* Submit Button */}
            <div
              onClick={onSubmitForm}
              disabled={isloading}
              className="tw:cursor-pointer tw:mt-8 tw:bg-[#dbbe78] tw:text-white tw:font-bold tw:text-[14px] tw:leading-[20px] tw:px-8 tw:py-[15px] tw:rounded-[5px] tw:flex tw:items-center tw:justify-center tw:gap-3 tw:w-full tw:lg:w-[335px] tw:mx-auto tw:transition-opacity tw:hover:opacity-90 tw:disabled:opacity-50 tw:disabled:cursor-not-allowed"
            >
              <span>{t('contact.Form.SubmitButton')}</span>
              <FiArrowRight size={20} color="#ffffff" />
            </div>
          </div>

          {/* Sidebar Info */}
          <div className="tw:lg:w-[300px] tw:lg:max-w-[300px] tw:px-5 tw:lg:px-0 tw:space-y-6">
            {/* Title */}
            <div className="tw:text-[22px] tw:leading-[26px] tw:text-[#282828] tw:font-libre-caslon-display">
              {t('contact.Sidebar.TitleLabel')}
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:w-full tw:bg-[#e8e8e8]"></div>

            {/* Email */}
            <div className="tw:space-y-2">
              <div className="tw:text-[15px] tw:leading-[22px] tw:text-[#8d8d8d] tw:font-hanken-grotesk">
                {t('contact.Sidebar.EmailLabel')}
              </div>
              <div className="tw:text-[15px] tw:leading-[22px] tw:text-[#282828] tw:font-hanken-grotesk">
                info@theluxuryfleet.com
              </div>
            </div>

            {/* Telephone */}
            <div className="tw:space-y-2">
              <div className="tw:text-[15px] tw:leading-[22px] tw:text-[#8d8d8d] tw:font-hanken-grotesk">
                {t('contact.Sidebar.TelephoneLabel')}
              </div>
              <div className="tw:text-[15px] tw:leading-[22px] tw:text-[#282828] tw:font-hanken-grotesk">
                (+81) 3 6822 8772
              </div>
            </div>

            {/* WhatsApp Business */}
            <div className="tw:space-y-2">
              <div className="tw:text-[15px] tw:leading-[22px] tw:text-[#8d8d8d] tw:font-hanken-grotesk">
                {t('contact.Sidebar.WhatsAppBusinessLabel')}
              </div>
              <div className="tw:text-[15px] tw:leading-[22px] tw:text-[#282828] tw:font-hanken-grotesk">
                (+81) 80 6862 8008
              </div>
            </div>

            {/* LINE QR Code */}
            <div className="tw:space-y-2">
              <div className="tw:text-[15px] tw:leading-[22px] tw:text-[#8d8d8d] tw:font-hanken-grotesk tw:underline tw:decoration-solid">
                {t('contact.Sidebar.LineQrCodeLabel')}
              </div>
              <div className="tw:w-[153px] tw:h-[149px] tw:bg-gray-200">
                <img
                  src={Line}
                  alt="LINE QR Code"
                  className="tw:w-full tw:h-full tw:object-cover"
                />
              </div>
            </div>

            {/* Address */}
            <div className="tw:space-y-2">
              <div className="tw:text-[15px] tw:leading-[22px] tw:text-[#8d8d8d] tw:font-hanken-grotesk">
                {t('contact.Sidebar.AddressLabel')}
              </div>
              <div className="tw:text-[15px] tw:leading-[22px] tw:text-[#282828] tw:font-hanken-grotesk tw:whitespace-pre-line">
                {t('contact.Sidebar.Address')}
              </div>
            </div>

            {/* Business Hours */}
            <div className="tw:space-y-2">
              <div className="tw:text-[15px] tw:leading-[22px] tw:text-[#8d8d8d] tw:font-hanken-grotesk">
                {t('contact.Sidebar.BusinessHoursLabel')}
              </div>
              <div className="tw:text-[15px] tw:leading-[22px] tw:text-[#282828] tw:font-hanken-grotesk">
                {t('contact.Sidebar.BusinessHours')}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Success Modal */}
      <SuccessModal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        title={t('contact.SuccessModal.Title')}
        message={t('contact.SuccessModal.Message')}
      />
    </FrontLayout>
  );
};

export default withAlert()(Contact);
